<template>
  <section class="reports">
    <article class="article">
      <div class="reports-body">
          <h2 class="article-title">虚拟化启动应用 双开永久免费</h2>
          <p class="article-title-desc">为您的多面生活助力</p>
          <div class="article-body">
            <div class="article-txt">
              <h2>软件功能</h2>
              <p>我们的软件使用虚拟化启动分身版应用，</p>
              <p>更安全稳定。</p>
              <p>支持微信、QQ、支付宝等应用免费双开，</p>
              <p>多账号在线无需手动切换，</p>
              <p>一部手机两个空间，双重安全保护您的信息安全。</p>
              <p>1、空间及应用锁</p>
              <p>支持应用加密，隐私防护更彻底。</p>
              <p>2、个性化定制</p>
              <h2 class="last-h2">商务合作</h2>
              <p>多开的应用可自由编辑图标和名称，一切随心定制。</p>
              <p>我们诚挚的欢迎各位来函、来电，与我们洽谈，</p>
              <p>展开更多丰富的合作，共赢未来！</p>
              <p>若需进行商务合作，可以通过以下方式联系我们：</p>
              <!-- <p>公司名称：上海次维网络科技有限公司</p>
              <p>联系地址：上海市宝山区沪太路6395号1-2层A区</p> -->
              <p>公司名称：合肥摩苍电子商务有限公司</p>
              <p>邮箱地址：service@moocang.net </p>
              <p>联系地址：安徽省合肥市经济技术开发区九龙路168号</p>
              <p>东湖创新中心9幢701室</p>
            </div>
            <img src="../assets/reports.png" />
          </div>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.reports-body{
  text-align: center;
  color: #ffffff;
  padding: 50px 0 150px 0;
  background: linear-gradient(0deg, #74E3D7, #33C4E3);
}
.article-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 54px;
  margin: 70px 0 100px 0;
}
.article-title-desc{
  font-size: 36px;
  margin-bottom: 84px;
}
.article-body{
  display: flex;
  justify-content: center;
  color: #154445;
  font-size: 20px;
  text-align: left;
}
.article-body img{
  margin-left: 20px;
}
.article-txt{
  margin-right: 20px;
}
.article-txt h2{
  font-size: 24px;
  margin-bottom: 20px;
}
.last-h2{
  margin-top: 40px;
}
.article-txt p{
  margin-bottom: 10px;
}
</style>